module.exports = __webpack_public_path__ + "static/media/locationMarker.949fe96c.svg";